<template>
    <div class="shaded m-4">
        <div v-if="getClonedAgent">
            <div class="tab-panel padded">
                <agent-commissions v-bind:isDisabled="isDisabled" @cancel="cancel" @save="save" @back="back" :showButtons="showButtons" :showExistingAgentSelector="showExistingAgentSelector" :selectedAgent="passedForm"></agent-commissions>
            </div>
        </div>

        <div v-else>
            <div class="shaded m-4">
                <div class="form-group row">
                    <div class="col-sm-12">
                        <div class="panel shaded">
                            <agent-commissions v-bind:isDisabled="isDisabled" @cancel="cancel" @save="save"></agent-commissions>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex'
    
    import AgentCommissions from './AgentCommissions'

    export default {
        props: {
            currentStep: Number,
            showButtons: {
                default: true
            },
            passedForm: {
                default: null
            },
            showExistingAgentSelector: {
                default: false
            },
            isDisabled: {
                type: Boolean,
                default: false
            },
        },
        computed: {
            ...mapGetters([
                'getClonedAgent',
            ]),
        },
        methods: {
            ...mapActions([
                'updateAgent',
                'addAgent',
                'clearClonedAgent'
            ]),
            cancel() {
                this.$emit('cancelling');
            },
            back() {
                this.$emit('goToPrevious', { form: this.getClonedAgent });
            },
            save() {
                if (this.getClonedAgent && this.getClonedAgent.id) {
                    this.updateAgent({
                        agent: this.getClonedAgent,
                        sendInvite: this.getClonedAgent.saveAndSend
                    });
                } else {
                    this.addAgent();
                }

                this.clearClonedAgent();
            }
        },
        components: {
            AgentCommissions,
        }
    }
</script>



// WEBPACK FOOTER //
// AgentCommissionsWrapper.vue?46788d82